import { Button } from "@dune/ui";
import { ArrowLeft } from "@untitled-ui/icons-react";

interface SendAllProps {
	backStep: () => void;
}

export default function SendAll({ backStep }: SendAllProps) {
	return (
		<div className="flex-1 flex items-center justify-center bg-white">
			<div className="space-y-6 w-full max-w-[380px]">
				<div className="flex flex-col items-center gap-6">
					<img src="/mail.png" alt="Mail Notification" className="w-32 mb-4" />
					<div className="text-3xl font-medium text-center">
						Tout est prêt !
					</div>
					<div className="text-xs text-gray-700 text-center">
						Notre équipe vérifie votre demande de partenariat,&nbsp;
						<b>
							vous serez notifié par email lorsque votre demande sera validée.
						</b>
					</div>
					<div className="flex justify-center">
						<Button variant="outline" onClick={backStep}>
							<ArrowLeft /> Retour formulaire
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
